// Same rule as marabot-api utils/listingSaleType.ts, which derives sale-vs-lease
// from the Trestle PropertyType and ignores the wizard's pick (MB-1519). Keep the
// two in step or the pill will disagree with what the api markets.
const isRentSide = (value: string): boolean =>
    value.includes("lease") || value.includes("rent");

export type SaleType = "sale" | "rent";

export const mlsSaleType = (
    mlsPropertyType: string | null | undefined,
): SaleType =>
    isRentSide((mlsPropertyType ?? "").toLowerCase()) ? "rent" : "sale";

// Commercial leases read "For Lease", every other rent-side type "For Rent".
export const mlsListingTypeLabel = (
    mlsPropertyType: string | null | undefined,
): string => {
    const value = (mlsPropertyType ?? "").toLowerCase();
    if (!isRentSide(value)) return "For Sale";
    return value.includes("commercial") ? "For Lease" : "For Rent";
};

export const MLS_LISTING_TYPE_NOTE =
    "We automatically market residential and commercial real estate for sale or lease using your MLS data. All listing changes must be made in your source MLS.";
export const MLS_LISTING_TYPE_INFO =
    "We read the property type on your MLS listing - Residential, Residential Lease, Commercial Sale, Commercial Lease and the rest - and write every post to match: a sale price for a sale, a monthly rate for a rental.";
export const MLS_LISTING_TYPE_INFO_TWO =
    "If a listing's type is wrong, correct it in your MLS first. The change reaches us in about 15 minutes.";
